<template>
  <div class="page page-section">
    <div class="list-options">
      <a-form layout="inline" class="options-form">
        <a-row :gutter="24">
          <a-col span="8">
            <a-form-item label="用户姓名"><a-input v-model="realname" placeholder="姓名" size="default" style="width: 200px" /></a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item label="登录账号"><a-input v-model="username" placeholder="账号" size="default" style="width: 200px" /></a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="flex items-center v-my-sm">
      <span></span>
      <div class="v-ml-auto">
        <a-button type="primary" icon="search" size="small" :loading="loading" @click="handleSearch">查询</a-button>
        <a-button icon="user-add" type="primary" class="v-ml-md" size="small" @click="openEdit()">添加用户</a-button>
        <!-- <a-button icon="usergroup-add" type="primary" class="v-ml-md" size="small" @click="handleCreate">创建授权会员</a-button> -->
        <!-- <a-button icon="export" type="link" class="v-ml-md bg-deep-orange text-white" size="small">导出Excel</a-button> -->
      </div>
    </div>
    <div class="list-table-container">
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :total="pagination.total" :current="pagination.page" :pageSize="pagination.pageSize" show-less-items show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
      <a-table :bordered="false" size="small" :columns="columns" :pagination="false" :data-source="list" :scroll="{ x: '100%' }" rowKey="id">
        <template slot="action" slot-scope="text, record">
          <a-space class="table-actions" :gutter="10">
            <!-- <span class="table-action" title="编辑"><a-icon type="edit" /></span> -->
            <!-- <span class="table-action" title="解禁" v-if="record.state === 0"><a-icon type="unlock" /></span>
            <span class="table-action" title="封禁" v-else-if="record.state === 1"><a-icon type="stop" /></span>-->
            <span class="table-action" title="重置密码" @click="openPwdDialog(record)"><a-icon type="key" /></span>
            <span class="table-action" title="编辑" @click="openEdit(record)"><a-icon type="form" /></span>
            <a-popconfirm title="确定删除该用户?" ok-text="是" cancel-text="否" @confirm="del(record.id)">
              <span class="table-action text-red" title="删除"><a-icon type="close" /></span>
            </a-popconfirm>
          </a-space>
        </template>
        <template slot="state" slot-scope="text, record">
          <span v-if="text === 1">正常</span>
          <span class="text-grey" v-else-if="text === 0">封禁</span>
        </template>
        <template slot="type" slot-scope="text, record">
          <span v-if="text === 1">主持人</span>
          <span v-else-if="text === 2">普通管理员</span>
        </template>
        <template slot="roles" slot-scope="text, record">
          <!--<a-tag color="red">{{ record.roles }}</a-tag>-->
          <div>
            <a-tag color="orange" v-for="role in record.roles" :key="role.id">{{ role.roleName }}</a-tag>
          </div>
        </template>
      </a-table>
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :total="pagination.total" :current="pagination.page" :pageSize="pagination.pageSize" show-less-items show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
    </div>
    <a-modal title="重置密码" :visible.sync="pwdDialog" @cancel="clear" @ok="resetPwd" width="400px">
      <a-form-model ref="form" :model="form" :rules="rules">
        <a-form-model-item :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }" label="新密码" prop="newPassword">
          <a-input type="password" v-model="form.newPassword" placeholder="请输入新密码" :max-length="50" style="width: calc(100% - 20px)" />
        </a-form-model-item>
        <a-form-model-item :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }" label="确认新密码" prop="newPassword2">
          <a-input type="password" v-model="form.newPassword2" placeholder="请再次输入新密码" :max-length="50" style="width: calc(100% - 20px)" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <EditForm ref="EditForm"></EditForm>
  </div>
</template>

<script>
import { listUser, deleteUser, resetPassword } from '@/api/system/user'
import EditForm from './user-edit-form'
export default {
  components: { EditForm },
  data() {
    return {
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          width: 60,
          align: 'center',
          customRender: (text, record, index) => index + 1,
        },
        {
          title: '登录账号',
          dataIndex: 'userName',
          // align: 'center',
          width: 130,
        },
        {
          title: '用户姓名',
          dataIndex: 'realName',
          // align: 'center',
          ellipsis: true,
          width: 120,
        },
        {
          title: '联系电话',
          dataIndex: 'phone',
          // align: 'center',
          width: 114,
        },
        {
          title: ' 电子邮箱',
          dataIndex: 'email',
          ellipsis: true,
          // align: 'center',
          width: 110,
          // scopedSlots: { customRender: 'type' },
        },
        // {
        //   title: '角色组',
        //   dataIndex: 'invGroupName',
        // },
        {
          title: ' 角色组',
          dataIndex: 'roles',
          // align: 'center',
          // width: 250,
          // ellipsis: true,
          scopedSlots: { customRender: 'roles' },
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 130,
          align: 'center',
          customRender: text => (text ? text.substring(0, 16) : ''),
        },
        {
          title: '状态',
          dataIndex: 'state',
          align: 'center',
          width: 70,
          scopedSlots: { customRender: 'state' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'action' },
        },
      ],
      list: [],
      realname: undefined,
      username: undefined,
      loading: false,
      pagination: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
      pwdDialog: false,
      record: {},
      form: {
        userId: null,
        newPassword: null,
        newPassword2: null,
      },
      rules: {
        newPassword: [
          { required: true, message: '新密码不允许为空', trigger: 'blur' },
          { pattern: /^(\w){4,20}$/, message: '密码长度至少为4位，不允许输入空格', trigger: 'blur' },
        ],
        newPassword2: [
          { required: true, message: '确认新密码不允许为空', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.newPassword) {
                callback(new Error('两次输入新密码不一致!'))
              } else {
                callback()
              }
            },
          },
        ],
      },
    }
  },
  methods: {
    handleSearch() {
      this.dataLoad()
    },
    del(id) {
      deleteUser(id).then(({ data }) => {
        if (data.success) {
          this.$message.success('删除成功')
        }
        this.dataLoad()
      })
    },
    openEdit(record) {
      this.$refs.EditForm.open(record)
    },
    openPwdDialog(data) {
      this.pwdDialog = true
      this.record = data
    },
    resetPwd() {
      this.$set(this.form, 'userId', this.record.id)
      this.$refs.form.validate(valid => {
        if (valid) {
          resetPassword(this.form).then(({ data }) => {
            if (data.success) {
              this.$message.success('操作成功')
              this.pwdDialog = false
            }
          })
        }
      })
    },
    clear() {
      this.pwdDialog = false
      this.$refs['form'].clearValidate()
      this.form = {
        userId: null,
        newPassword: null,
        newPassword2: null,
      }
    },
    dataLoad(page = 1, pageSize = 10) {
      this.loading = true
      let params = {
        page,
        pageSize,
        username: this.username,
        realname: this.realname,
      }
      listUser(params).then(({ data }) => {
        if (data.success) {
          let { current, size, total, records } = data.result
          this.list = records
          this.pagination = {
            page: current,
            pageSize: size,
            total,
          }
        }
        this.loading = false
      })
    },
    onPageChange(page, pageSize) {
      this.dataLoad(page, pageSize)
    },
  },
  mounted() {
    this.dataLoad()
  },
}
</script>
